// John Eldhose 20200831
import React, { Component } from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import Loading from './Loading';
import { getData } from './api';

class Dealers extends Component {

  state = {
    loading: true,
    dealers: [],
    id: -1
  }
  componentWillMount() {
    getData('getDealers')
      .then((dea) => {
        if(dea['status'] === 'true')
          this.setState({ dealers: dea['data'], loading: false });
      })
      .catch((error) => { console.log(error); })
  }
  handleChange = (e) => {
    this.setState({ id: e.target.value });
    this.props.handleDealer(this.state.dealers[e.target.value]);
  }

  render() {
    if(this.state.loading)
      return (
        (this.props.hideLoding === 'undefined' || !this.props.hideLoding) ? <Loading /> : <div />
      );
    else {
      var required = (typeof this.props.required === 'undefined') ? false : this.props.required;
      return (
        <TextField
          select
          required={required}
          fullWidth
          label={
            <FormattedMessage
              id='Your Carlson Dealer'
              defaultMessage='Your Carlson Dealer'
            />
          }
          value={this.state.id}
          onChange={this.handleChange}
          margin="normal"
          helperText={
            <FormattedMessage
              id='Please pick a dealer from the dropdown above'
              defaultMessage='Please pick a dealer from the dropdown above'
            />
          }
        >
          {this.state.dealers.map((d, id) => (
            <MenuItem key={d.ACCOUNTID} value={id}>
              {d.ACCOUNT + '; ' + d.MAINPHONE + '; ' + d.EMAIL}
            </MenuItem>
          ))}
        </TextField>
      );
    }
  }
}

export default Dealers;



// WEBPACK FOOTER //
// ./src/components/lib/Dealers.js